import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { getSlateColorToken } from "@faire/retailer-shared/SlateMappings/getSlateColorToken";
import { getContentWidthPixels } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Styling/sectionContentWidth";
import { getConsolidatedSpacingValues, getResponsiveSpacingPixels } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Styling/spacing";
import { assignInlineVars, mapResponsivePropToCSSVars } from "@faire/retailer-visitor-shared/lib/tailwindUtils";
import { Column } from "@faire/web--source/slate/Layout";
import { ColorTokenKey } from "@faire/web-api--source/indigofair/data/ColorTokenKey";
import { Spacing } from "@faire/web-api--source/indigofair/data/Spacing";
import classNames from "classnames";
import React from "react";
var varMobilePadding = {
    variable: "--f-sdui-section-padding",
    className: "p-[--f-sdui-section-padding]"
};
var varTabletPadding = {
    variable: "--f-sdui-section-padding-md",
    className: "md:p-[--f-sdui-section-padding-md]"
};
var varDesktopPadding = {
    variable: "--f-sdui-section-padding-lg",
    className: "lg:p-[--f-sdui-section-padding-lg]"
};
var varXLargePadding = {
    variable: "--f-sdui-section-padding-xl",
    className: "xl:p-[--f-sdui-section-padding-xl]"
};
export var SDUISectionStyleWrapper = function(param) {
    var sectionStyles = param.sectionStyles, sectionVisibility = param.sectionVisibility, children = param.children;
    var clientTopPadding = getResponsiveSpacingPixels(Spacing.SPACING_NONE, sectionStyles === null || sectionStyles === void 0 ? void 0 : sectionStyles.responsive_top_padding);
    var clientHorizontalPadding = getResponsiveSpacingPixels(Spacing.SPACING_NONE, sectionStyles === null || sectionStyles === void 0 ? void 0 : sectionStyles.responsive_horizontal_padding);
    var clientBottomPadding = getResponsiveSpacingPixels(Spacing.SPACING_NONE, sectionStyles === null || sectionStyles === void 0 ? void 0 : sectionStyles.responsive_bottom_padding);
    var responsivePaddingShorthand = getConsolidatedSpacingValues(clientTopPadding, clientBottomPadding, clientHorizontalPadding, clientHorizontalPadding);
    var _mapResponsivePropToCSSVars = mapResponsivePropToCSSVars(responsivePaddingShorthand, {
        mobileAndAbove: varMobilePadding,
        tabletAndAbove: varTabletPadding,
        desktopAndAbove: varDesktopPadding,
        xLargeAndAbove: varXLargePadding
    }), paddingClassnames = _mapResponsivePropToCSSVars.classes, paddingStyles = _mapResponsivePropToCSSVars.vars;
    return /*#__PURE__*/ _jsx(Column, {
        align: "center",
        justify: "center",
        className: "w-full",
        style: {
            backgroundColor: getSlateColorToken(sectionStyles === null || sectionStyles === void 0 ? void 0 : sectionStyles.background_color, ColorTokenKey.COLOR_TOKEN_KEY_UNKNOWN)
        },
        children: /*#__PURE__*/ _jsx(Column, {
            "data-test-id": "section-style-content-wrapper",
            align: "center",
            justify: "center",
            className: classNames.apply(void 0, [
                "w-full",
                paddingClassnames
            ].concat(_to_consumable_array(getSectionVisibilityClassNames(sectionVisibility)))),
            style: _object_spread({
                maxWidth: getContentWidthPixels(sectionStyles === null || sectionStyles === void 0 ? void 0 : sectionStyles.content_width)
            }, assignInlineVars(paddingStyles)),
            children: children
        })
    });
};
var getSectionVisibilityClassNames = function(sectionVisibility) {
    if (!sectionVisibility) {
        return [];
    }
    return Object.entries(sectionVisibility).map(function(param) {
        var _param = _sliced_to_array(param, 2), viewport = _param[0], shouldShow = _param[1];
        return shouldShow ? VISIBLE_CLASS_NAMES[viewport] : HIDDEN_CLASS_NAMES[viewport];
    });
};
var VISIBLE_CLASS_NAMES = {
    mobileAndAbove: "flex",
    tabletAndAbove: "md:flex",
    desktopAndAbove: "lg:flex"
};
var HIDDEN_CLASS_NAMES = {
    mobileAndAbove: "hidden",
    tabletAndAbove: "md:hidden",
    desktopAndAbove: "lg:hidden"
};
